import { ApolloLink } from "./ApolloLink.js";
export var empty = ApolloLink.empty;
